(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './compose-multiplatform-core-compose-ui-ui.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './androidx-window-window-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./androidx-window-window-core.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-adaptive-adaptive'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-material3-adaptive-adaptive'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-adaptive-adaptive'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'compose-multiplatform-core-compose-material3-adaptive-adaptive'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-adaptive-adaptive'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'compose-multiplatform-core-compose-material3-adaptive-adaptive'.");
    }
    if (typeof globalThis['androidx-window-window-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material3-adaptive-adaptive'. Its dependency 'androidx-window-window-core' was not found. Please, check whether 'androidx-window-window-core' is loaded prior to 'compose-multiplatform-core-compose-material3-adaptive-adaptive'.");
    }
    globalThis['compose-multiplatform-core-compose-material3-adaptive-adaptive'] = factory(typeof globalThis['compose-multiplatform-core-compose-material3-adaptive-adaptive'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-material3-adaptive-adaptive'], globalThis['kotlin-kotlin-stdlib'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['androidx-window-window-core']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_compose_ui_ui, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_androidx_window_window_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var VOID = kotlin_kotlin.$_$.d;
  var emptyList = kotlin_kotlin.$_$.c9;
  var equals = kotlin_kotlin.$_$.sf;
  var protoOf = kotlin_kotlin.$_$.eh;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var hashCode = kotlin_kotlin.$_$.bg;
  var joinToString = kotlin_kotlin.$_$.aa;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var get_LocalDensity = kotlin_org_jetbrains_compose_ui_ui.$_$.t6;
  var get_LocalWindowInfo = kotlin_org_jetbrains_compose_ui_ui.$_$.h7;
  var toSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t1;
  var DpSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.o;
  var Companion_getInstance = kotlin_androidx_window_window_core.$_$.a;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var _DpSize___get_width__impl__o3d5gt = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.u2;
  var Dp__compareTo_impl_tlg3dl = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.i2;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.b6;
  var _Dp___get_value__impl__geb1vb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l2;
  var _DpSize___get_height__impl__5xueo2 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.s2;
  var WindowSizeClass_init_$Create$ = kotlin_androidx_window_window_core.$_$.c;
  var _Dp___init__impl__ms3zkb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h2;
  var Dp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.p;
  var setOf = kotlin_kotlin.$_$.sb;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Posture, 'Posture', Posture);
  initMetadataForClass(WindowAdaptiveInfo, 'WindowAdaptiveInfo');
  initMetadataForObject(DpWidthSizeClasses, 'DpWidthSizeClasses');
  initMetadataForObject(DpHeightSizeClasses, 'DpHeightSizeClasses');
  //endregion
  var androidx_compose_material3_adaptive_Posture$stable;
  var androidx_compose_material3_adaptive_HingeInfo$stable;
  function Posture(isTabletop, hingeList) {
    isTabletop = isTabletop === VOID ? false : isTabletop;
    hingeList = hingeList === VOID ? emptyList() : hingeList;
    this.zxl_1 = isTabletop;
    this.axm_1 = hingeList;
  }
  protoOf(Posture).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Posture))
      return false;
    if (!(this.zxl_1 === other.zxl_1))
      return false;
    if (!equals(this.axm_1, other.axm_1))
      return false;
    return true;
  };
  protoOf(Posture).hashCode = function () {
    var result = getBooleanHashCode(this.zxl_1);
    result = imul(31, result) + hashCode(this.axm_1) | 0;
    return result;
  };
  protoOf(Posture).toString = function () {
    return 'Posture(isTabletop=' + this.zxl_1 + ', ' + ('hinges=[' + joinToString(this.axm_1, ', ') + '])');
  };
  var androidx_compose_material3_adaptive_WindowAdaptiveInfo$stable;
  function WindowAdaptiveInfo(windowSizeClass, windowPosture) {
    this.bxm_1 = windowSizeClass;
    this.cxm_1 = windowPosture;
  }
  protoOf(WindowAdaptiveInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WindowAdaptiveInfo))
      return false;
    if (!this.bxm_1.equals(other.bxm_1))
      return false;
    if (!this.cxm_1.equals(other.cxm_1))
      return false;
    return true;
  };
  protoOf(WindowAdaptiveInfo).hashCode = function () {
    var result = this.bxm_1.hashCode();
    result = imul(31, result) + this.cxm_1.hashCode() | 0;
    return result;
  };
  protoOf(WindowAdaptiveInfo).toString = function () {
    return 'WindowAdaptiveInfo(windowSizeClass=' + this.bxm_1.toString() + ', windowPosture=' + this.cxm_1.toString() + ')';
  };
  function currentWindowAdaptiveInfo(supportLargeAndXLargeWidth, $composer, $changed, $default) {
    var supportLargeAndXLargeWidth_0 = supportLargeAndXLargeWidth;
    var $composer_0 = $composer;
    if (!(($default & 1) === 0))
      supportLargeAndXLargeWidth_0 = false;
    $composer_0.m30(760658738);
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalDensity();
    var $composer_1 = $composer_0;
    // Inline function 'kotlin.with' call
    var $this$with = $composer_1.u31(this_0);
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_1 = get_LocalWindowInfo();
    var $composer_2 = $composer_0;
    var tmp$ret$3 = $composer_2.u31(this_1);
    var tmp1_group = $this$with.g5f(toSize(tmp$ret$3.bbr()));
    $composer_0.n30();
    var windowSize = tmp1_group;
    var tmp;
    if (supportLargeAndXLargeWidth_0) {
      tmp = computeFromDpSizeV2(Companion_getInstance(), windowSize);
    } else {
      tmp = computeFromDpSize(Companion_getInstance(), windowSize);
    }
    return new WindowAdaptiveInfo(tmp, calculatePosture($composer_0, 0));
  }
  function computeFromDpSizeV2(_this__u8e3s4, windowSize, supportedWidthSizeClasses, supportedHeightSizeClasses) {
    supportedWidthSizeClasses = supportedWidthSizeClasses === VOID ? DpWidthSizeClasses_getInstance().jxm_1 : supportedWidthSizeClasses;
    supportedHeightSizeClasses = supportedHeightSizeClasses === VOID ? DpHeightSizeClasses_getInstance().nxm_1 : supportedHeightSizeClasses;
    return computeFromDpSize(_this__u8e3s4, windowSize, supportedWidthSizeClasses, supportedHeightSizeClasses);
  }
  function computeFromDpSize(_this__u8e3s4, windowSize, supportedWidthSizeClasses, supportedHeightSizeClasses) {
    supportedWidthSizeClasses = supportedWidthSizeClasses === VOID ? DpWidthSizeClasses_getInstance().ixm_1 : supportedWidthSizeClasses;
    supportedHeightSizeClasses = supportedHeightSizeClasses === VOID ? DpHeightSizeClasses_getInstance().nxm_1 : supportedHeightSizeClasses;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = supportedWidthSizeClasses.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var it = element.m5f_1;
      if (Dp__compareTo_impl_tlg3dl(_DpSize___get_width__impl__o3d5gt(windowSize), it) >= 0) {
        destination.j1(element);
      }
    }
    // Inline function 'kotlin.collections.maxOf' call
    var iterator = destination.t();
    if (!iterator.u())
      throw NoSuchElementException_init_$Create$();
    var it_0 = iterator.v().m5f_1;
    var maxValue = _Dp___get_value__impl__geb1vb(it_0);
    while (iterator.u()) {
      var it_1 = iterator.v().m5f_1;
      var v = _Dp___get_value__impl__geb1vb(it_1);
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = maxValue;
      maxValue = Math.max(a, v);
    }
    var tmp = maxValue;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = supportedHeightSizeClasses.t();
    while (_iterator__ex2g4s_0.u()) {
      var element_0 = _iterator__ex2g4s_0.v();
      var it_2 = element_0.m5f_1;
      if (Dp__compareTo_impl_tlg3dl(_DpSize___get_height__impl__5xueo2(windowSize), it_2) >= 0) {
        destination_0.j1(element_0);
      }
    }
    // Inline function 'kotlin.collections.maxOf' call
    var iterator_0 = destination_0.t();
    if (!iterator_0.u())
      throw NoSuchElementException_init_$Create$();
    var it_3 = iterator_0.v().m5f_1;
    var maxValue_0 = _Dp___get_value__impl__geb1vb(it_3);
    while (iterator_0.u()) {
      var it_4 = iterator_0.v().m5f_1;
      var v_0 = _Dp___get_value__impl__geb1vb(it_4);
      // Inline function 'kotlin.comparisons.maxOf' call
      var a_0 = maxValue_0;
      maxValue_0 = Math.max(a_0, v_0);
    }
    var tmp$ret$10 = maxValue_0;
    return WindowSizeClass_init_$Create$(tmp, tmp$ret$10);
  }
  function DpWidthSizeClasses() {
    DpWidthSizeClasses_instance = this;
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp.dxm_1 = _Dp___init__impl__ms3zkb(0);
    var tmp_0 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_0.exm_1 = _Dp___init__impl__ms3zkb(600);
    var tmp_1 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_1.fxm_1 = _Dp___init__impl__ms3zkb(840);
    var tmp_2 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_2.gxm_1 = _Dp___init__impl__ms3zkb(1200);
    var tmp_3 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_3.hxm_1 = _Dp___init__impl__ms3zkb(1600);
    this.ixm_1 = setOf([new Dp(this.dxm_1), new Dp(this.exm_1), new Dp(this.fxm_1)]);
    this.jxm_1 = setOf([new Dp(this.dxm_1), new Dp(this.exm_1), new Dp(this.fxm_1), new Dp(this.gxm_1), new Dp(this.hxm_1)]);
  }
  var DpWidthSizeClasses_instance;
  function DpWidthSizeClasses_getInstance() {
    if (DpWidthSizeClasses_instance == null)
      new DpWidthSizeClasses();
    return DpWidthSizeClasses_instance;
  }
  function DpHeightSizeClasses() {
    DpHeightSizeClasses_instance = this;
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp.kxm_1 = _Dp___init__impl__ms3zkb(0);
    var tmp_0 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_0.lxm_1 = _Dp___init__impl__ms3zkb(480);
    var tmp_1 = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp_1.mxm_1 = _Dp___init__impl__ms3zkb(900);
    this.nxm_1 = setOf([new Dp(this.kxm_1), new Dp(this.lxm_1), new Dp(this.mxm_1)]);
  }
  var DpHeightSizeClasses_instance;
  function DpHeightSizeClasses_getInstance() {
    if (DpHeightSizeClasses_instance == null)
      new DpHeightSizeClasses();
    return DpHeightSizeClasses_instance;
  }
  function get_DefaultPosture() {
    _init_properties_WindowAdaptiveInfo_nonAndroid_kt__sx5a5y();
    return DefaultPosture;
  }
  var DefaultPosture;
  function currentWindowAdaptiveInfo_0($composer, $changed) {
    _init_properties_WindowAdaptiveInfo_nonAndroid_kt__sx5a5y();
    var $composer_0 = $composer;
    return currentWindowAdaptiveInfo(false, $composer_0, 6, 0);
  }
  function calculatePosture($composer, $changed) {
    _init_properties_WindowAdaptiveInfo_nonAndroid_kt__sx5a5y();
    var $composer_0 = $composer;
    return get_DefaultPosture();
  }
  var properties_initialized_WindowAdaptiveInfo_nonAndroid_kt_vmadt8;
  function _init_properties_WindowAdaptiveInfo_nonAndroid_kt__sx5a5y() {
    if (!properties_initialized_WindowAdaptiveInfo_nonAndroid_kt_vmadt8) {
      properties_initialized_WindowAdaptiveInfo_nonAndroid_kt_vmadt8 = true;
      DefaultPosture = new Posture();
    }
  }
  //region block: init
  androidx_compose_material3_adaptive_Posture$stable = 0;
  androidx_compose_material3_adaptive_HingeInfo$stable = 0;
  androidx_compose_material3_adaptive_WindowAdaptiveInfo$stable = 0;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = currentWindowAdaptiveInfo;
  _.$_$.b = currentWindowAdaptiveInfo_0;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-material3-adaptive-adaptive.js.map
